<template>
  <div :class="['terms-and-conditions-block', { opened: isOpened }]">
    <div class="terms-and-conditions-panel-title">
      {{ title }}
    </div>
    <div
      v-dompurify-html="content"
      class="terms-and-conditions-panel-content"
    />
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      content: {
        type: String,
        required: true
      },
      isOpened: {
        type: Boolean,
        default: true,
        required: false
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .terms-and-conditions-block {
    background-color: $blue-grey-light;
    border-radius: 4px;
    margin: 0 -23px;
    padding: 20px 23px;

    @include bp-mf-tablet {
      margin: 30px 0 20px;
    }

    &:not(.opened):hover {
      background-color: $gray-light-hover;
    }

    &.opened {

      .terms-and-conditions-panel-content {
        display: block;
      }
    }

    @media print {
      background-color: white !important;
    }

    .terms-and-conditions-panel-title {
      position: relative;
      display: flex;
      align-items: center;
      font-weight: 500;
      color: $blue-dark;
      font-size: em(16);
      line-height: 19px;
      margin: 0 0 24px;

      @include bp-mf-tablet {
        margin: 8px 0 16px;
      }

      &::before {
        @include filled-icon-font();

        content: $filled-icon-termsandconditions;
        margin-right: 23px;
        margin-left: -5px;
        font-size: em(24);
        color: $gray-active-text-color;

        @include bp-mf-tablet {
          margin-left: 0;
          margin-right: 18px;
        }
      }
    }

    .terms-and-conditions-panel-content {
      display: none;
      padding: 0 11px 30px;

      @include bp-mf-tablet {
        padding: 4px 61px 36px;
      }

      @media print {
        display: block;
      }
    }

    /deep/ ul {
      padding: 0;
      list-style: disc;
    }

    /deep/ li {
      padding-left: 8px;
      @include tcStyle();

      &:not(:last-child) {
        margin-bottom: 18px;
      }

      &:before {
        display: none;
      }

      ul {
        margin: 10px 0 10px 15px;
        list-style-type: circle;

        li {
          padding-left: 8px;
          @include tcStyle();

          &:not(:last-child) {
            margin-bottom: 6px;
          }
        }
      }
    }

    /deep/ strong {
      font-weight: 500;
    }

    /deep/ a {
      color: $blue-medium;

      &:hover {

        @include bp-mf-tablet {
          color: $blue-light;
        }
      }
    }
  }
</style>
